module.exports = __webpack_public_path__ + "media/images/athletes/1822-7365e36e5476434bcf33f4e53ee65ebc.png";